module.exports = __webpack_public_path__ + "img/powerstar_thumbnail.1a19bd0b.png";